import { Redirect, Route, Switch } from 'react-router-dom'

import routes from 'app/routes'
import ForgotPassword from 'features/auth/login/ForgotPassword'
import Login from 'features/auth/login/Login'

function UnauthorizedRoutes() {
  return (
    <Switch>
      <Route path="/" exact component={Login} />
      <Route
        path={routes.auth.forgotPassword}
        exact
        component={ForgotPassword}
      />
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  )
}

export default UnauthorizedRoutes
